import dynamic from 'next/dynamic';

const FeaturedHoneymoon = dynamic(() => import('./FeaturedHoneymoon'));

export default FeaturedHoneymoon;
